import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { BodyLarge400, BodyLarge500, TitleSmall500 } from '@nebula/global-styles';

import GUIDANCE_MESSAGES from '../PaymentMethodAuthorization/constants/messaging';
import { PaymentContext } from '../PaymentOrchestrator/PaymentContextProvider';
import { PAYMENT_ERROR_GROUPS, PAYMENT_ERROR_TYPES } from '../PaymentOrchestrator/constants/paymentErrors';
import AuthorizationPrompt from '../PaymentMethodAuthorization/AuthorizationPrompt';
import { Guidance, Main } from './index.styles';
import paymentChangeAuthorizedTransition from '../PaymentOrchestrator/transitions/paymentMethodChangeAuthorizedTransition';
import {
  track3dsChallengeFailure,
  track3dsOutputTokenReceived,
} from '../../helpers/changePaymentMethodNewJourney/analytics';
import usePageView from '../../hooks/usePageView';

const onGuidanceRef = node => {
  if (node) {
    node.scrollIntoView({ behavior: 'smooth' });
  }
};

const PAGE_NAME = 'ProdMoveChangePaymentMethodAuthorizationPage';

const PaymentChangeAuthorization = () => {
  const paymentContext = useContext(PaymentContext);
  const { tokens, raisePaymentError, restartPaymentFlow, isWebview } = paymentContext;

  const dispatch = useDispatch();

  usePageView(PAGE_NAME);

  const handleSuccess = outputToken => {
    track3dsOutputTokenReceived();
    paymentChangeAuthorizedTransition(paymentContext, outputToken.id)(dispatch);
  };

  const handleFailure = error => {
    track3dsChallengeFailure(error?.code, error?.message);
    raisePaymentError({
      message: error?.message,
      group: PAYMENT_ERROR_GROUPS.METHOD_CHANGE,
      type: PAYMENT_ERROR_TYPES.METHOD_CHANGE.UNSUCCESSFUL,
    });
    restartPaymentFlow();
  };

  return (
    <Main>
      <Guidance ref={onGuidanceRef}>
        <TitleSmall500>Confirm your card details</TitleSmall500>
        <BodyLarge400 as="span">{`${GUIDANCE_MESSAGES.HEADING} `}</BodyLarge400>
        <BodyLarge500 as="span">
          {isWebview ? GUIDANCE_MESSAGES.WARNING_APP : GUIDANCE_MESSAGES.WARNING_WEB}
        </BodyLarge500>
      </Guidance>
      <div>
        <AuthorizationPrompt
          actionTokenId={tokens.authorizationInput}
          onToken={handleSuccess}
          onError={handleFailure}
        />
      </div>
    </Main>
  );
};

export default PaymentChangeAuthorization;
